export const readApolloError = (errors) => {
  if (errors?.graphQLErrors?.length) {
    return { code: errors.graphQLErrors[0]?.extensions.code, message: errors.graphQLErrors[0]?.message }
  } else if (errors) {
    return { code: 'Error', messagge: errors.message }
  }
}
